__turbopack_context__.v({
  "userInput": "styles-module__rmRuzW__userInput",
});
